"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const prefix = `/api/ac/v2/subscription/mail/published`;
const API = {
    subscribe: `${prefix}/subscribe`,
    unsubscribe: `${prefix}/unsubscribe`,
};
class MailSubscription {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async subscribe(email) {
        await this._httpClient.post(API.subscribe, {
            email,
        });
        return {
            result: null,
            entities: {},
        };
    }
    async unsubscribe() {
        await this._httpClient.delete(API.unsubscribe);
        return {
            result: null,
            entities: {},
        };
    }
}
exports.default = MailSubscription;
